import React, { useEffect, useState } from 'react';
import ErrorBoundaryRoutes from '../../../../../app/shared/error/error-boundary-routes';
import { Route, useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import { Home } from './home';
import { PrivateRoute } from '../../../../../app/shared/auth/private-route';
import { AUTHORITIES } from '../../config/constants';
import { getSession } from '../../shared/reducers/authentication';

const PageRoute = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const isLoading = useAppSelector(state => state.authentication.loading);
  const navigate = useNavigate();
  const sessionHasBeenFetched = useAppSelector(state => state.authentication.sessionHasBeenFetched);
  useEffect(() => {
    dispatch(getSession());
  }, []);

  const [userAuthenticated, setUserAuthenticated] = useState();
  const [isLoadingAuthentication, setIsLoadingAuthentication] = useState();

  useEffect(() => {
    setUserAuthenticated(isAuthenticated || false);
  }, [isAuthenticated]);

  useEffect(() => {
    setIsLoadingAuthentication(isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log('Auth Check:', userAuthenticated, isLoadingAuthentication);
    if (isLoadingAuthentication == false && userAuthenticated == false) {
      const utmParams = new URLSearchParams();

      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(key => {
        const value = localStorage.getItem(key);
        if (value) {
          // persist for later pages
          localStorage.setItem(key, value);
          // forward to keycloak
          utmParams.append(key, value);
        }
      });

      const keycloakSignupURL = `https://auth.doyouhaveacase.ai/realms/do-you-have-a-case/protocol/openid-connect/registrations?client_id=${process.env.IS_DEV ? 'web_app' : 'web_app_prod'}&response_type=code&scope=openid%20profile%20email%20offline_access&redirect_uri=${window.location.origin}/signin&kc_locale=en&${utmParams.toString()}`;

      window.location.href = keycloakSignupURL;
    }
  }, [isLoadingAuthentication]);

  return (
    <>
      {isAuthenticated && (
        <div className="view-routes">
          <ErrorBoundaryRoutes>
            <Route
              path="/"
              element={
                <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
                  <Home />
                </PrivateRoute>
              }
            />
          </ErrorBoundaryRoutes>
        </div>
      )}
    </>
  );
};

export default PageRoute;
